// eslint-disable-next-line import/prefer-default-export
export const IDENTIFICATION_ERROR = {
  'Document.Illegible': 'Your document could not be scanned. Try from another device with better image quality',
  'Document.Illegitimate': 'Illegitimate Document',
  'DocumentSides.DataMismatch': 'The front and back data of the Document do not match',
  'DocumentType.Incorrect': 'Incorrect Document Type',
  'DocumentSides.Mismatch': 'Documents sides do not match',
  'Document.WrongSide': 'Wrong side of the document',
  'Luminance.TooHigh': 'High luminance detected',
  'Luminance.TooLow': 'Low luminance detected',
  'Photo.NotDetected': 'Photo not detected in the document',
  'IdDocument.NotDetected': 'No Identification Document detected',
  'Image.InvalidSize': 'invalid image size. For {idType} the document image should have a width of at least {width}',
}
